// extracted by mini-css-extract-plugin
export default {"top":"itemView_docList_top__0R2HT","wrapper":"itemView_docList_wrapper__HTJ9a"};